<template>
  <div 
    :class="['ecp-button', type]" 
    @click="handleAuth"
  >
    <div class="logo-name" v-if="isJakarta">JaCarta PKI</div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  type: {
    type: String,
    default: null
  }
});

const emit = defineEmits(['auth']);

const isJakarta = computed(() => props.type === 'jakarta');

const handleAuth = () => {
  try {
    if (props.type) {
      emit('auth', props.type);
    }
  } catch (error) {
    console.error('Error in ButtonItem auth handler:', error);
  }
};
</script>